import Vue from 'vue'
import createApp from './main'
// import fastClick from 'yike-fastclick'
import FastClick from 'fastclick'
import Bus from '../node_modules/@imp/package/lib/bus'
import ZybPage from '../node_modules/@imp/package/packages/zyb-page/components/index.vue'
import ZybPicture from '../node_modules/@imp/package/packages/zyb-picture/components/index.vue'
import ZybContainer from '../node_modules/@imp/package/packages/zyb-container/components/index.vue'
import ZybButton from '../node_modules/@imp/package/packages/zyb-button/components/index.vue'
import ZybHotarea from '../node_modules/@imp/package/packages/zyb-hotarea/components/index.vue'
import ZybCountdown from '../node_modules/@imp/package/packages/zyb-countdown/components/index.vue'
import ZybPayButton from '../node_modules/@imp/package/packages/zyb-pay-button/components/index.vue'
import ZybPayDialog from '../node_modules/@imp/package/packages/zyb-pay-dialog/components/index.vue'
import ZybRolling from '../node_modules/@imp/package/packages/zyb-rolling/components/index.vue'
import ZybGradeHotarea from '../node_modules/@imp/package/packages/zyb-grade-hotarea/components/index.vue'
import ZybInfoCarousel from '../node_modules/@imp/package/packages/zyb-info-carousel/components/index.vue'
Vue.use(Bus)
// fastClick.attach(document.body)
FastClick.attach(document.body)
FastClick.prototype.focus = function(targetElement: any) {
  let length
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month'
  ) {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  } else {
    targetElement.focus()
  }
}

// 客户端组件按需加载
let componentList = [...(<any>window).__PAGE_DATA__.pageInfo.componentList]
const funArr: Array<object> = []
interface IChild {
  componentList: Array<object>
  componentName: string
}
interface IName {
  name: string
}
interface IComponentKey {
  name: string
  extendOptions: IName
}
interface IComponent {
  default: IComponentKey
}
const breadth = (arr: Array<object>) => {
  let result: Array<string> = []
  let queue = arr
  while (queue.length > 0) {
    ;[...queue].forEach(child => {
      queue.shift()
      result.push((child as IChild).componentName)
      ;(child as IChild).componentList &&
        queue.push(...(child as IChild).componentList)
    })
  }
  const nameSet = new Set(result)
  return nameSet
}
function toLine(name: string) {
  return name.replace(/([A-Z])/g, '-$1').toLowerCase()
}

const nameArr = breadth(componentList)
nameArr.forEach(item => {
  const str = toLine(item).substr(1, toLine(item).length)
  funArr.push(
    import(
      /* webpackChunkName: "[request]" */
      `../node_modules/@imp/package/packages/${str}/components/index.vue`
    )
  )
})

Vue.component('ZybPage', ZybPage)
Vue.component('ZybPicture', ZybPicture)
Vue.component('ZybContainer', ZybContainer)
Vue.component('ZybButton', ZybButton)
Vue.component('ZybHotarea', ZybHotarea)
Vue.component('ZybPayButton', ZybPayButton)
Vue.component('ZybCountdown', ZybCountdown)
Vue.component('ZybPayDialog', ZybPayDialog)
Vue.component('ZybRolling', ZybRolling)
Vue.component('ZybGradeHotarea', ZybGradeHotarea)
Vue.component('ZybInfoCarousel', ZybInfoCarousel)
let hasRegister = [
  'ZybPage',
  'ZybPicture',
  'ZybContainer',
  'ZybButton',
  'ZybHotarea',
  'ZybPayButton',
  'ZybCountdown',
  'ZybPayDialog',
  'ZybRolling',
  'ZybGradeHotarea',
  'ZybInfoCarousel',
]
// console.log('开始')
Promise.all(funArr).then(arr => {
  arr.forEach(item => {
    if (
      (item as IComponent).default.extendOptions &&
      (item as IComponent).default.extendOptions.name &&
      !hasRegister.includes((item as IComponent).default.extendOptions.name)
    ) {
      Vue.component(
        (item as IComponent).default.extendOptions.name,
        (item as IComponent).default
      )
    } else if (!hasRegister.includes((item as IComponent).default.name)) {
      Vue.component(
        (item as IComponent).default.name,
        (item as IComponent).default
      )
    }
  })
  createApp({ pageData: (<any>window).__PAGE_DATA__ }).$mount('#app')
})
// createApp({ pageData: (<any>window).__PAGE_DATA__ }).$mount('#app')
// createApp((<any>window).__PAGE_DATA__).$mount('#app')
// createApp({}).$mount('#app')
